import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useRef, useLayoutEffect } from 'react';
import {
    ArrowLeft,
    ShoppingCart,
    CheckCircle,
    Crown,
    Flame,
    Zap,
    Star,
    Heart,
    Sparkles,
    Gem,
    Shield,
    Clock
} from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';
import RankPurchaseModal from '../components/RankPurchaseModal';
import { useAuth } from '../contexts/AuthContext';

const rankConfig = {
    Vip: {
        fullName: 'وی‌آی‌پی',
        color: 'from-blue-500 to-blue-700',
        icon: Crown,
        image: '/vip.jpg',
        badge: null,
        category: 'roleplay',
        features: [
            'دسترسی به شنل‌های مختلف (cape/)',
            'پر کردن غذا (food/)',
            'پر کردن جان (heal/)',
            'تغییر رنگ چت در نیم‌تگ (chatcolor/)',
            'دسترسی به کیت هفتگی VIP',
            'دریافت ۶۰۰,۰۰۰ پول سرور',
            'دریافت ۵ چتر'
        ],
        kit: ['۱۲۸ آیرون', '۶۴ گلد', '۳۲ دایموند', '۱۶ ندرایت اسکرپ', '۴ امرالد', '۱ بیکن', '۲ شالکر باکس', '۱ الایترا', '۱ هد استیو']
    },
    Mvp: {
        fullName: 'ام‌وی‌پی',
        color: 'from-purple-500 to-purple-700',
        icon: Star,
        image: '/mvp.jpg',
        badge: null,
        category: 'roleplay',
        features: [
            'بالا رفتن از دیوار (spider/)',
            'دسترسی به شنل‌های مختلف (cape/)',
            'پر کردن غذا (food/)',
            'پر کردن جان (heal/)',
            'تغییر رنگ چت (chatcolor/)',
            'دسترسی به کیت هفتگی MVP',
            'دریافت ۸۰۰,۰۰۰ پول سرور',
            'دریافت ۱۰ چتر'
        ],
        kit: ['۲۵۶ آیرون', '۱۲۸ گلد', '۶۴ دایموند', '۲۴ ندرایت اسکرپ', '۶ امرالد', '۲ بیکن', '۴ شالکر باکس', '۲ الایترا', '۱ توتم', 'هد استیو، اسکلتون، کریپر']
    },
    Dragon: {
        fullName: 'دراگون',
        color: 'from-emerald-500 to-emerald-700',
        icon: Flame,
        image: '/dragon.jpg',
        badge: 'محبوب‌ترین',
        category: 'roleplay',
        features: [
            'پرواز در سرور (fly/)',
            'تلپورت به بازیکن (tp/)',
            'تغییر زمان سرور (time/)',
            'بالا رفتن از دیوار (spider/)',
            'دسترسی به شنل (cape/)',
            'پر کردن غذا و جان (food/ + heal/)',
            'تغییر رنگ چت (chatcolor/)',
            'دسترسی به کیت هفتگی Dragon',
            'دریافت ۱,۰۰۰,۰۰۰ پول سرور',
            'دریافت ۲۰ چتر'
        ],
        kit: ['۵۱۲ آیرون', '۲۵۶ گلد', '۱۲۸ دایموند', '۲۸ ندرایت اسکرپ', '۸ امرالد', '۲ بیکن', '۶ شالکر باکس', '۳ الایترا', '۲ توتم', 'هد ویدر، کریپر، استیو، اسکلتون', '۱ کلاه تنفس زیر آب', '۲ اندرچست']
    },
    Eternity: {
        fullName: 'اترنیتی',
        color: 'from-rose-500 to-rose-700',
        icon: Clock,
        image: '/eternity.png',
        badge: 'به صرفه',
        category: 'roleplay',
        features: [
            'پرواز دائمی (fly/)',
            'تلپورت آزاد (tp/)',
            'تغییر زمان و آب‌وهوا',
            'بالا رفتن از دیوار (spider/)',
            'شنل + غذا + جان + رنگ چت',
            'دسترسی به کیت هفتگی Eternity',
            'دریافت ۵,۰۰۰,۰۰۰ پول سرور',
            'دریافت ۳۲ چتر لوکس'
        ],
        kit: ['۱۰۲۴ آیرون', '۵۱۲ گلد', '۲۵۶ دایموند', '۶۴ ندرایت اسکرپ', '۱۲ امرالد', '۵ بیکن', '۴ شالکر باکس', '۴ الایترا', '۴ توتم', 'هد دراگون، پیگلین، ویدر و ...', '۳ کلاه تنفس', '۴ اندرچست']
    },
    Sponsor: {
        fullName: 'اسپانسر',
        color: 'from-purple-500 to-purple-700',
        icon: Crown,
        image: '/sponsor.png',
        badge: 'VIP',
        category: 'roleplay',
        features: [
            'دسترسی به کریتیو (creative/)',
            'قابلیت تلپورت (tp/)',
            'قابلیت پرواز (fly/)',
            'قابلیت روز و شب (time/)',
            'قابلیت بالا رفتن از دیوارها (spider/)',
            'داشتن شنل‌های مختلف (cape/)',
            'قابلیت پر کردن غذا (food/)',
            'قابلیت پر کردن جون (heal/)',
            'دسترسی به کیت اسپانسر، اترنیتی، دراگون، ام‌وی‌پی و وی‌آی‌پی (kit/)',
            'دسترسی به ماشین‌های ویژه (VIP)'
        ],
        kit: [
            '۲۰۴۸ آیرون',
            '۱۰۲۴ گلد',
            '۵۱۲ دایمند',
            '۱۲۸ ندرایت اسکرپ',
            '۳۲ امرالد',
            '۶ بیکن',
            '۵ شالکر باکس',
            '۸ الایترا',
            '۸ توتم',
            '۷ هد استیو',
            '۵ هد اسکلتون',
            '۳ هد کریپر',
            '۳ هد ویدر',
            '۳ هد دراگون',
            '۳ هد پیگلین',
            '۵ کلاه زیرآبی',
            '۷ اندرچست'
        ],
        benefits: [
            'دریافت ۸,۰۰۰,۰۰۰ پول سرور',
            'دریافت ۴۸ چتر'
        ],
        note: 'کریتیو این رنک به صورت محدود می‌باشد و شما به علاوه بر مکانیزم کریتیو ماینکرفت فقط دسترسی به بلاک‌های بیلد دارید.'
    },
    Lite:
        { fullName: 'لایت', color: 'from-green-500 to-green-700', icon: Sparkles, image: '/lite.jpg', badge: null, category: 'bedwars', features: ['۲ کیت اختصاصی', '۲ کیل افکت', '۲ کیل مسیج', '۲ نوع معماری و ۸ نوع پارتیکل', '۱۵ رنگ آرمور در لابی', '۱ بال', 'دسترسی به ۲۴ شنل'] },

    Blitz:
        { fullName: 'بلیتز', color: 'from-amber-500 to-amber-700', icon: Zap, image: '/blitz.jpg', badge: 'پرفروش', category: 'bedwars', features: ['۳ کیت اختصاصی', '۴ کیل افکت', '۲ بد بریک افکت', '۴ کیل مسیج', '۴ نوع معماری و ۱۶ نوع پارتیکل', '۱۵ رنگ آرمور در لابی', 'بوستر XP دو برابر', '۲ بال', 'دسترسی به ۴۶ شنل'] },

    Nebula:
        { fullName: 'نبیولا', color: 'from-fuchsia-500 to-fuchsia-700', icon: Star, image: '/nebula.jpg', badge: null, category: 'bedwars', features: ['۵ کیت اختصاصی', '۵ کیل افکت', '۴ بد بریک افکت', '۷ کیل مسیج', '۶ نوع معماری و ۲۶ نوع پارتیکل', '۱۵ رنگ آرمور در لابی', '۶ بال زیبا', 'بوستر XP و کوین دو برابر', 'دسترسی به ۶۸ شنل'] },

    Plutonium:
        { fullName: 'پلوتونیوم', color: 'from-teal-500 to-teal-700', icon: Gem, image: '/plutonium.jpg', badge: 'حرفه‌ای', category: 'bedwars', features: ['۶ کیت اختصاصی', '۷ کیل افکت', '۵ بد بریک افکت', '۱۳ کیل مسیج', '۸ نوع معماری و ۳۶ نوع پارتیکل', '۱۵ رنگ آرمور در لابی', '۸ بال زیبا', '۱۸ افکت مرگ', 'بوستر XP سه برابر + کوین دو برابر', 'دسترسی به ۹۲ شنل'] },

    Heaven:
        { fullName: 'هیون (Heaven)', color: 'from-slate-300 via-gray-400 to-slate-600', icon: Sparkles, image: '/heaven.png', badge: null, category: 'pillars', features: [
            'تگ بالای سر و چت اختصاصی سفید خالص با براکت‌های شیک نقره‌ای',
            'دسترسی به ۲ کیت آغازین شوالیه (Knight) و معدنچی (Miner)',
            '۲ اسکین اختصاصی ستون: چوب بلوط (Oak Log) و آجر قلعه (Castle Bricks)',
            'کیج‌های اختصاصی شیشه‌ای سبز و میله‌های آهنی',
            '۳ کیل‌افکت جذاب: فوران خون، صاعقه آسمانی و آتش‌بازی',
            'صداهای اختصاصی مرگ و قتل روستایی و زامبی',
            'پیام‌های قتل سفارشی در چت سرور (Honorable و Savage)',
            'رقص‌های پیروزی کول اسنپ (Cold Snap) و ارتش تورک',
            '۳ مدل بال اختصاصی: بال پری (Fairy)، داوینچی (Davinci) و روخ (Ruch)',
            'دسترسی به کیپ‌های کلاسیک و پایه (سفید و مشکی)',
            'دسترسی به ۱۵ رنگ زره چرمی در لابی سرور',
            'افکت‌های نوری ابر و رعدوبرق در لابی'
        ] },

    Crystal:
        { fullName: 'کریستال (Crystal)', color: 'from-purple-600 via-fuchsia-600 to-pink-600', icon: Zap, image: '/crystal.png', badge: 'پیشنهادی', category: 'pillars', features: [
            'تگ بالای سر و چت اختصاصی صورتی و بنفش نئونی',
            'شامل تمامی امکانات و دسترسی‌های رنک Heaven',
            'بوستر ۲ برابری کسب XP و سکه سرور (Double XP & Coins)',
            'دسترسی به ۳ کیت ویژه چوب‌بر (Lumberjack)، جادوگر (Wizard) و پزشک (Medic)',
            '۶ اسکین ستون اختصاصی: یخ فشرده، اسلایم، ماگما، آمتیست، آبسیدین گریان و طلا',
            '۸ مدل کیج ۳بعدی و متحرک (وان حمام، قوطی، کتابخانه، برج دروازه، میز فوتبال، تلسکوپ و ترامپولین)',
            '۵ کیل‌افکت حماسی: شکستن یخ، فوران قلب، سندان مرگبار، گرداب آتش و عروج روح',
            '۹ صدای قتل و ۱۴ صدای مرگ اختصاصی ماب‌های ماینکرفت',
            '۱۱ پیام قتل سفارشی و انیمیشنی در چت سرور',
            '۶ مدل رقص پیروزی پرطرفدار (دیسکو، آتش‌بازی، خشم ثور، یی‌ها، باران سندان و بارش شهاب‌سنگ)',
            '۵ مدل بال فانتزی: اژدها (Dragon)، فرشته (Angel)، مرگ (Death)، شیطان (Devil) و خفاش جهنمی (Hellbat)',
            'کیپ‌های کمیاب و رده اپیک سرور (Rare & Epic)',
            'تریل‌های نوری ردپا (ردپای قلب، لاوا و گلوله برفی)',
            'پارتیکلهای معلق آتش، لاوا، ویلیجر و ردستون'
        ] },

    Pillar:
        { fullName: 'پیلار (Pillar)', color: 'from-emerald-600 via-teal-600 to-emerald-800', icon: Crown, image: '/pillar.png', badge: 'برتر VIP', category: 'pillars', features: [
            'بالاترین و کامل‌ترین رده VIP سرور با تگ و پیشوند چت سبز زمردی درخشان',
            'دسترسی کامل به تمامی امکانات رنک‌های Crystal و Heaven',
            'باز بودن ۱۰۰٪ تمامی کازمتیک‌های حال و آینده سرور (دسترسی نامحدود Wildcard)',
            'بوستر ۳ برابری فوق‌العاده XP سرور (Triple XP Booster)',
            'دسترسی به کیت ویژه و قدرتمند تروریست (Terrorist Kit)',
            'اسکین‌های سلطنتی و لجندری ستون زمرد (Emerald) و ندرایت (Netherite)',
            'کیج‌های متحرک و پیشرفته ۳بعدی تردمیل (Treadmill) و دوچرخه (Bicycle)',
            'دسترسی به تمامی کیج‌ها و رقص‌های پیروزی سرور بدون محدودیت',
            '۴ کیل‌افکت افسانه‌ای: بارش شهاب‌سنگ (Meteor Strike)، خوک پرنده، خشم اژدها (Dragon Wrath) و سیاهچاله کیهانی (Black Hole)',
            'رقص پیروزی افسانه‌ای اژدهاسواری (Dragon Rider)',
            'صداهای قتل و مرگ لجندری غرش اژدها، پرتو گاردین و نفرین الدر',
            'پیام‌های قتل سلطنتی طلایی (Golden) و اژدها (Dragon)',
            'دسترسی کامل به تمام بال‌ها و کیپ‌های لجندری سرور',
            'دسترسی به تمامی ۱۸ صدای فریاد مرگ (Death Cries)',
            'دسترسی به تمامی ۹ تریل ردپا (آتش، پرتال، حباب، دود، چمن، ردستون، تخم مرغ و...)',
            'افکت‌های ویژه بدنه (هاله قلب، ارواح سرگردان و شیشه معلق)'
        ] },

    'L-GroveStreet':
        { fullName: 'گنگستر GroveStreet', color: 'from-emerald-950 via-emerald-800 to-green-950', icon: Shield, image: '/grovestreet.jpg', badge: 'تک لیدر', category: 'roleplay', features: ['دوره ۳۰ روزه اختصاصی (تک لیدر)', 'ظرفیت: ۱ لیدر + ۲ ممبر (مجموع ۳ نفر)', 'بالاترین رده خلافکاری سرور', 'دسترسی به تمام بذرهای پیشرفته مواد', 'سرقت مسلحانه از بانک و اسلحهسازی', 'بازار اعضا، جیب‌بری و دستگاه چاپ پول', 'زره سنگین دیفندر'] },

    'L-Ballas':
        { fullName: 'گنگستر Ballas', color: 'from-purple-950 via-purple-800 to-indigo-950', icon: Crown, image: '/ballas.jpg', badge: 'تک لیدر', category: 'roleplay', features: ['دوره ۳۰ روزه اختصاصی (تک لیدر)', 'ظرفیت: ۱ لیدر + ۲ ممبر (مجموع ۳ نفر)', 'بالاترین رده خلافکاری سرور', 'دسترسی به تمام بذرهای پیشرفته مواد', 'سرقت مسلحانه از بانک و اسلحهسازی', 'بازار اعضا، جیب‌بری و دستگاه چاپ پول', 'زره سنگین دیفندر'] },

    'L-Ravex':
        { fullName: 'مافیا Ravex', color: 'from-amber-950 via-yellow-800 to-amber-900', icon: Flame, image: '/ravex.jpg', badge: 'تک لیدر', category: 'roleplay', features: ['دوره ۳۰ روزه اختصاصی (تک لیدر)', 'ظرفیت: ۱ لیدر + ۳ ممبر (مجموع ۴ نفر)', 'رده دوم خلافکاری سرور', 'دسترسی به سرقت از بانک', 'زرادخانه اسلحه و قاچاق اعضا', 'جعل اسکناس و بذرهای تجاری'] },

    'L-Zyrex':
        { fullName: 'مافیا Zyrex', color: 'from-cyan-950 via-teal-800 to-cyan-900', icon: Zap, image: '/zyrex.jpg', badge: 'تک لیدر', category: 'roleplay', features: ['دوره ۳۰ روزه اختصاصی (تک لیدر)', 'ظرفیت: ۱ لیدر + ۳ ممبر (مجموع ۴ نفر)', 'رده دوم خلافکاری سرور', 'دسترسی به بازار سیاه', 'تجهیزات سنگین مافیایی', 'کارتل اسلحه'] }

};

const prices = { Vip: 150000, Mvp: 300000, Dragon: 520000, Eternity: 850000, Sponsor: 3000000, Lite: 100000, Blitz: 200000, Nebula: 400000, Plutonium: 800000, 'L-GroveStreet': 900000, 'L-Ballas': 900000, 'L-Ravex': 750000, 'L-Zyrex': 750000, Heaven: 160000, Crystal: 330000, Pillar: 740000 };

const RankDetailPage = () => {
    const scrollRef = useRef(null);
    const { rankType } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const [rank, setRank] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);

    useLayoutEffect(() => {
        if (showPurchaseModal) {
            scrollRef.current?.scrollTo(0, 0);
        }
    }, [showPurchaseModal]);

    useEffect(() => {
        const fetchRank = async () => {
            setLoading(true);
            try {
                const { data } = await axios.get('/api/ranks/available');
                const apiRank = data.find(r => (r.type || '').toLowerCase() === rankType.toLowerCase());

                const key = Object.keys(rankConfig).find(k => k.toLowerCase() === rankType.toLowerCase());
                if (!key) throw new Error();

                setRank({
                    type: key,
                    price: apiRank?.price || prices[key],
                    isSoldOut: apiRank?.isSoldOut || false,
                    daysRemaining: apiRank?.daysRemaining || null,
                    currentLeader: apiRank?.currentLeader || null,
                    ...rankConfig[key]
                });
            } catch {
                const key = Object.keys(rankConfig).find(k => k.toLowerCase() === rankType.toLowerCase());
                if (key) {
                    setRank({ type: key, price: prices[key], ...rankConfig[key] });
                } else {
                    toast.error('رنک یافت نشد!');
                    navigate('/ranks');
                }
            } finally {
                setLoading(false);
            }
        };
        fetchRank();
    }, [rankType, navigate]);

    if (loading) {
        return (
            <div className="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
                <div className="animate-spin rounded-full h-12 w-12 border-2 border-emerald-600 border-t-transparent"></div>
            </div>
        );
    }

    if (!rank) return null;

    const Icon = rank.icon;

    return (
        <AnimatePresence mode="wait">
            <motion.div
                ref={scrollRef}
                key="rank-detail"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-50 bg-[#050811] text-white overflow-y-auto"
                dir="rtl"
            >
                {/* هدر ساده */}
                <div className="sticky top-0 z-10 bg-[#050811]/90 backdrop-blur-xl border-b border-white/10">
                    <div className="container mx-auto px-4 py-3 flex items-center justify-between">
                        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-400 hover:text-emerald-400 transition text-sm font-bold">
                            <ArrowLeft className="w-5 h-5" />
                            <span>بازگشت</span>
                        </button>
                        <h2 className="text-base font-bold text-emerald-400">{rank.fullName}</h2>
                    </div>
                </div>

                <div className="container mx-auto px-4 py-8 max-w-6xl">
                    <div className="grid lg:grid-cols-2 gap-8 items-start">
                        {/* تصویر رنک - ارتفاع ثابت و استیکی */}
                        <div className="lg:sticky lg:top-24">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 }}
                                className="relative rounded-3xl overflow-hidden shadow-2xl bg-white/5 border border-white/10"
                            >
                                <div className={`relative bg-gradient-to-br ${rank.color}`}>
                                    <img
                                        src={rank.image}
                                        alt={rank.fullName}
                                        className="w-full object-cover opacity-80"
                                        style={{ height: '420px' }}
                                        onError={(e) => e.target.src = 'https://via.placeholder.com/1280x720/10b981/ffffff?text=' + rank.fullName}
                                    />
                                    <div className="absolute inset-0 bg-black/40" />
                                    {rank.badge && (
                                        <div className="absolute top-4 right-4 bg-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                                            {rank.badge}
                                        </div>
                                    )}
                                    <div className="absolute bottom-6 left-6 text-white">
                                        <Icon className="w-14 h-14 mb-2 drop-shadow-lg" />
                                        <h1 className="text-3xl font-black drop-shadow-lg">{rank.fullName}</h1>
                                        <p className="text-xs mt-1 opacity-80">{rank.category === 'bedwars' ? 'بدوارز' : rank.category === 'pillars' ? 'پیلارز' : 'رول‌پلی'}</p>
                                    </div>
                                </div>
                            </motion.div>
                        </div>

                        {/* اطلاعات */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                            className="space-y-6"
                        >
                            {/* قیمت */}
                            <div className="bg-white/5 border border-white/10 rounded-3xl p-6 backdrop-blur-xl">
                                <div className="text-3xl font-black text-white">
                                    {rank.price.toLocaleString()} <span className="text-base font-normal text-gray-400">تومان</span>
                                </div>
                                <p className="text-xs text-gray-400 mt-2">۳۰ روزه • فعال‌سازی آنی</p>
                            </div>

                            {/* امکانات */}
                            <div className="bg-white/5 border border-white/10 rounded-3xl p-6 backdrop-blur-xl">
                                <h3 className="text-lg font-bold mb-4 flex items-center gap-2 text-white">
                                    <Shield className="w-5 h-5 text-emerald-400" />
                                    امکانات رنک
                                </h3>
                                <div className="space-y-3">
                                    {rank.features.map((f, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, x: -20 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ delay: 0.3 + i * 0.05 }}
                                            className="flex items-center gap-3"
                                        >
                                            <CheckCircle className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                                            <span className="text-sm text-gray-300">{f}</span>
                                        </motion.div>
                                    ))}
                                </div>

                                {rank.kit && (
                                    <div className="mt-6 pt-4 border-t border-white/10">
                                        <h4 className="text-sm font-bold text-amber-400 mb-3">کیت هفتگی</h4>
                                        <div className="grid grid-cols-2 gap-2">
                                            {rank.kit.map((item, i) => (
                                                <div key={i} className="flex items-center gap-2 text-xs text-gray-400">
                                                    <div className="w-1.5 h-1.5 bg-amber-400 rounded-full"></div>
                                                    <span>{item}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* دکمه خرید */}
                            {rank.isSoldOut ? (
                                <button
                                    disabled
                                    className="w-full bg-red-950/80 border border-red-800/80 text-red-300 font-bold text-base py-4 rounded-2xl shadow-xl flex flex-col items-center justify-center gap-1 cursor-not-allowed opacity-90"
                                >
                                    <span className="font-black text-base">ناموجود (در اختیار پلیر دیگر)</span>
                                    {rank.daysRemaining && (
                                        <span className="text-xs font-medium text-red-400">
                                            احتمال آزادی ظرف {rank.daysRemaining} روز آینده
                                        </span>
                                    )}
                                </button>
                            ) : (
                                <button
                                    onClick={() => {
                                        if (!isAuthenticated) {
                                            toast.error('برای خرید رنک ابتدا وارد حساب کاربری خود شوید');
                                            navigate('/login');
                                            return;
                                        }
                                        setShowPurchaseModal(true);
                                    }}
                                    className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-base py-4 rounded-2xl shadow-xl flex items-center justify-center gap-2 transition-all"
                                >
                                    <ShoppingCart className="w-5 h-5" />
                                    خرید رنک {rank.fullName}
                                </button>
                            )}

                            <p className="text-center text-xs text-gray-500">
                                پرداخت امن • پشتیبانی ۲۴ ساعته • فعال‌سازی آنی
                            </p>
                        </motion.div>
                    </div>
                </div>

                {showPurchaseModal && <RankPurchaseModal rank={rank} onClose={() => setShowPurchaseModal(false)} />}
            </motion.div>
        </AnimatePresence>
    );
};

export default RankDetailPage;